import React, { useState } from 'react';
import CallSummaryTable     from '../Reports/Components/CallSummaryTable.jsx';
import ConvertedLeadsTable  from './Components/ConvertedLeadsTable.jsx';
import FilterBar from '../../FilterBar.jsx';
import { DateRangeContext } from '../../Context.js';
import CampaignCallCountTable from './Components/CampaignCallCountTable.jsx';
import CategoryCallCountTable from './Components/CategoryCallCountTable.jsx';
import RegionCallCountTable from './Components/RegionCallCountTable.jsx';
import AgentCallCountTable from './Components/AgetnWiseCallCount.jsx';

const Report = () => {
  // the single source of truth for every table
  const [dateRange, setDateRange] = useState({ filterType: 'none', start: '', end: '' });

  return (
    <DateRangeContext.Provider value={dateRange}>
      <FilterBar onChange={setDateRange} />

      <div className="container">
        <CallSummaryTable  />
      </div>

      <div className="container">
        <ConvertedLeadsTable />
      </div>

       <div className="container">
        <CampaignCallCountTable />
      </div>
       <div className="container">
        <CategoryCallCountTable />
      </div>
       <div className="container">
        <RegionCallCountTable />
      </div>
      <div className="container">
        <AgentCallCountTable />
      </div>

      {/* add more tables here – they’ll all respond automatically */}
    </DateRangeContext.Provider>
  );
};

export default Report;
